module.exports = __webpack_public_path__ + "static/img/down-arrow-white.157f6258.svg";